import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Nav, Tab } from 'react-bootstrap';
import { Calendar, CreditCard, FileText, BarChart3, Users } from 'lucide-react';
import LeaveCreditAllocation from './LeaveCreditAllocation';
import LeaveBalance from './LeaveBalance';
import LeaveRequests from './LeaveRequests';
import LeaveStatement from './LeaveStatement';
import '../../styles/LeaveManagement.css';

const LeaveManagement = () => {
     const [activeTab, setActiveTab] = useState('balance');
     const [userRole, setUserRole] = useState('');
     const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

     useEffect(() => {
          const role = sessionStorage.getItem('user_role');
          setUserRole(role);

          const handleResize = () => setIsMobile(window.innerWidth < 768);
          window.addEventListener('resize', handleResize);
          return () => window.removeEventListener('resize', handleResize);
     }, []);

     const isHR = userRole === 'HR' || userRole === 'SUPER_ADMIN';

     return (
          <Container fluid className="leave-management-container" style={{ padding: isMobile ? '6px' : '12px' }}>
               <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
                    <Row>
                         <Col lg={12}>
                              <Card className="shadow-sm">
                                   <Card.Header className="bg-white" style={{ padding: isMobile ? '4px 6px' : '6px 10px' }}>
                                        <Nav
                                             variant="pills"
                                             className={`leave-nav-pills ${isMobile ? 'flex-column' : 'flex-row'} gap-1`}
                                             style={{ fontSize: isMobile ? '12px' : '13px' }}
                                        >
                                             <Nav.Item style={{ flex: isMobile ? 'auto' : '1' }}>
                                                  <Nav.Link
                                                       eventKey="balance"
                                                       className="d-flex align-items-center justify-content-center"
                                                       style={{ padding: isMobile ? '4px 6px' : '10px 16px' }}
                                                  >
                                                       <CreditCard size={isMobile ? 16 : 14} className="me-2" />
                                                       {isMobile ? 'Balance' : 'Leave Balance'}
                                                  </Nav.Link>
                                             </Nav.Item>
                                             <Nav.Item style={{ flex: isMobile ? 'auto' : '1' }}>
                                                  <Nav.Link
                                                       eventKey="requests"
                                                       className="d-flex align-items-center justify-content-center"
                                                       style={{ padding: isMobile ? '4px 6px' : '10px 16px' }}
                                                  >
                                                       <FileText size={isMobile ? 16 : 14} className="me-2" />
                                                       {isMobile ? 'Requests' : 'Leave Requests'}
                                                  </Nav.Link>
                                             </Nav.Item>
                                             <Nav.Item style={{ flex: isMobile ? 'auto' : '1' }}>
                                                  <Nav.Link
                                                       eventKey="statement"
                                                       className="d-flex align-items-center justify-content-center"
                                                       style={{ padding: isMobile ? '4px 6px' : '10px 16px' }}
                                                  >
                                                       <BarChart3 size={isMobile ? 16 : 14} className="me-2" />
                                                       {isMobile ? 'Statement' : 'Leave Statement'}
                                                  </Nav.Link>
                                             </Nav.Item>
                                             {isHR && (
                                                  <Nav.Item style={{ flex: isMobile ? 'auto' : '1' }}>
                                                       <Nav.Link
                                                            eventKey="credit"
                                                            className="d-flex align-items-center justify-content-center"
                                                            style={{ padding: isMobile ? '4px 6px' : '10px 16px' }}
                                                       >
                                                            <Users size={isMobile ? 16 : 14} className="me-2" />
                                                            {isMobile ? 'Credit' : 'Credit Leaves'}
                                                       </Nav.Link>
                                                  </Nav.Item>
                                             )}
                                        </Nav>
                                   </Card.Header>
                                   <Card.Body className="p-0">
                                        <Tab.Content>
                                             <Tab.Pane eventKey="balance">
                                                  <LeaveBalance />
                                             </Tab.Pane>
                                             <Tab.Pane eventKey="requests">
                                                  <LeaveRequests />
                                             </Tab.Pane>
                                             <Tab.Pane eventKey="statement">
                                                  <LeaveStatement />
                                             </Tab.Pane>
                                             {isHR && (
                                                  <Tab.Pane eventKey="credit">
                                                       <LeaveCreditAllocation />
                                                  </Tab.Pane>
                                             )}
                                        </Tab.Content>
                                   </Card.Body>
                              </Card>
                         </Col>
                    </Row>
               </Tab.Container>
          </Container>
     );
};

export default LeaveManagement;